import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    formContentRow: {
      display: 'flex',
      alignItems: 'baseline',
    },
    rangeDivider: {
      padding: theme.spacing(0, 0.5),
    },
  };
};
